import { render } from "./WidgetCustomerOrdersDaily.vue?vue&type=template&id=5a2eda27&scoped=true&ts=true"
import script from "./WidgetCustomerOrdersDaily.vue?vue&type=script&lang=ts"
export * from "./WidgetCustomerOrdersDaily.vue?vue&type=script&lang=ts"

import "./WidgetCustomerOrdersDaily.vue?vue&type=style&index=0&id=5a2eda27&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2eda27"]])

export default __exports__